var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"id":"download-json-btn","icon":"","x-large":"","color":"primary"},on:{"click":_vm.downloadJson}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("fab fa-js")])],1)]}}])},[_vm._v(" Export to JSON ")])
}
var staticRenderFns = []

export { render, staticRenderFns }